export const weatherKeys = ['nebel', 'frost', 'sonnenschein', 'wirbelsturm'] as const;
export const WEATHER_KEY = 'weather';
